import { BTargetItem } from '@pharmsnap/shared/components'
import { useRequest } from '@pharmsnap/shared/composition/useRequest'
import { sharedCtx } from '@pharmsnap/shared/context'
import { defineComponent, PropType, watch } from '@vue/composition-api'
import { BBasicLoadingCard } from '../BBasicLoadingCard/BBasicLoadingCard'
export const BTargetFetchListCard = defineComponent({
  name: 'BTargetFetchListCard',
  props: {
    ids: {
      type: Array as PropType<string[]>,
      required: true,
    },
    coreIds: {
      type: Array as PropType<string[]>,
      default: () => [],
    },
  },
  setup(props, ctx) {
    const { loading, data } = useRequest(
      {
        requestFn: sharedCtx.service.target.getBatchTargets.bind(sharedCtx.service.target),
      },
      props.ids
    )
    watch(loading, () => {
      ctx.emit('update')
    })
    return {
      loading,
      data,
    }
  },
  render() {
    return (
      <BBasicLoadingCard loading={this.loading}>
        <div class="flex flex-wrap">
          {this.data?.map((item) => {
            return <BTargetItem class="mr-1 mb-1" data={item} coreIds={this.coreIds}></BTargetItem>
          })}
        </div>
      </BBasicLoadingCard>
    )
  },
})
